export type DocumentationRoleValues = 'MENTEE' | 'MENTOR';

export const documentationRoles: DocumentationRoleValues[] = [
  'MENTEE',
  'MENTOR',
];

enum DOCUMENTATION_ROLE {
  MENTEE = 'Mentoré',
  MENTOR = 'Mentor',
}

export default DOCUMENTATION_ROLE;
